import { IOrderMaterialUseCase, IOrder } from "@lib";
import { IOrderMaterialGetDto, IOrderMaterialCreateDto, IOrderMaterialUpdateDto } from "@lib";
import { DataLoadException } from "@/core/exceptions";
import { Api } from "../axios";

export class OrderMaterialUseCase implements IOrderMaterialUseCase {
    public async getFromStore(
        companyId: string,
        officeId: string,
        orderId: string,
        dto: IOrderMaterialGetDto,
    ): Promise<IOrder> {
        try {
            const response = await Api.post<IOrder>(
                `/companies/${companyId}/offices/${officeId}/orders/${orderId}/materials/get`,
                dto,
            );
            return response.data;
        } catch (e: any) {
            throw new DataLoadException(e);
        }
    }

    public async create(
        companyId: string,
        officeId: string,
        orderId: string,
        dto: IOrderMaterialCreateDto,
    ): Promise<IOrder> {
        try {
            const response = await Api.post<IOrder>(
                `/companies/${companyId}/offices/${officeId}/orders/${orderId}/materials`,
                dto,
            );
            return response.data;
        } catch (e: any) {
            throw new DataLoadException(e);
        }
    }

    public async update(
        companyId: string,
        officeId: string,
        orderId: string,
        materialId: string,
        dto: IOrderMaterialUpdateDto,
    ): Promise<IOrder> {
        try {
            const response = await Api.put<IOrder>(
                `/companies/${companyId}/offices/${officeId}/orders/${orderId}/materials/${materialId}`,
                dto,
            );
            return response.data;
        } catch (e: any) {
            throw new DataLoadException(e);
        }
    }

    public async delete(companyId: string, officeId: string, orderId: string, materialId: string): Promise<IOrder> {
        try {
            const response = await Api.delete<IOrder>(
                `/companies/${companyId}/offices/${officeId}/orders/${orderId}/materials/${materialId}`,
            );
            return response.data;
        } catch (e: any) {
            throw new DataLoadException(e);
        }
    }
}
